import { useState, useEffect } from 'react';
import { Button, Typography, CircularProgress, Alert } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

const BriefingCheckButton = ({ bookingId, onAction, isLoading, error, text }) => {
  const [countdown, setCountdown] = useState(0);
  const [countdownStart, setCountdownStart] = useState(null);

  useEffect(() => {
    if (countdown > 0) {
      const interval = setInterval(() => {
        const elapsed = Math.floor((Date.now() - countdownStart) / 1000);
        const remaining = Math.max(0, 3 - elapsed);
        setCountdown(remaining);
      }, 100);
      return () => clearInterval(interval);
    }
  }, [countdown, countdownStart]);

  const handleClick = e => {
    e.stopPropagation();
    if (countdown > 0) {
      // Second click within 3 seconds
      onAction(bookingId);
      setCountdown(0);
    } else {
      // First click - start new countdown
      setCountdownStart(Date.now());
      setCountdown(3);
    }
  };

  if (isLoading) {
    return <CircularProgress size={24} />;
  }

  if (error) {
    return (
      <Alert severity='error' sx={{ maxWidth: '180px' }}>
        {error}
      </Alert>
    );
  }

  return (
    <Button
      variant='contained'
      color='success'
      onClick={handleClick}
      sx={{
        width: text ? 'auto' : '20px',
        transition: 'none',
        '&:hover': {
          backgroundColor: 'success.main',
        },
      }}
    >
      {countdown > 0 ? (
        <Typography variant='body2' color='text.primary'>
          {countdown}s
        </Typography>
      ) : text ? (
        text
      ) : (
        <CheckIcon />
      )}
    </Button>
  );
};

export default BriefingCheckButton;
